import React from "react";
import Header from "./Header/Header";
import NavBar from "../../Shared/Navbar/NavBar";

const HeaderMain = () => {
  return (
    <>
      <NavBar />
      <Header />
    </>
  );
};

export default HeaderMain;
